import React from 'react';
import AsignarCursosEstudiantesCatalog from './AsignarCursosEstudiantesCatalog';

export default function AsignarCursosEstudiantesPage() {
    return (
        <AsignarCursosEstudiantesCatalog />
    );
}
